// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.

/** Notes others shared with the signed-in person (the sidebar and the shared note page). */
import { unwrap } from "@granite/api-client";

import { api } from "./api.js";

export const sharedNotesQuery = {
  queryKey: ["shared-notes"],
  queryFn: async () => unwrap(await api.GET("/v1/me/shared-notes")).items,
};

/** A shared note's name: its file name without ".md". */
export const sharedTitle = (path: string) => (path.split("/").pop() ?? path).replace(/\.md$/i, "");
